module.exports = __webpack_public_path__ + "static/media/so-algo--chicken1.11767f68.jpg";